// extracted by mini-css-extract-plugin
var _1 = "page_description__-1axf";
export { _1 as "description" }
